
(function(){
    angular.module('ui2.0Service').factory('contractLineItemService',['$http','$timeout', '$uibModal', '$rootScope', function ($http,$timeout, $modal, $rootScope) {

        let filteredCount;
        var allowedExtensions = ["xlsx","xlsm"];

        return {
            generateDocFile:generateDocFile,
            loadDocument:loadDocument,
            getWordFiles:getWordFiles,
            uploadBulkFile:uploadBulkFile,
            checkIfDocumentUpdated:checkIfDocumentUpdated,
            formatDate: formatDate,
            templateFileDownload: templateFileDownload,
            getRequiredData:getRequiredData,
            downloadAllTables
        }

        function downloadAllTables() {
            const {entityTypeId,entityId} = getRequiredData() || {};
            const URL = addtStamp(`/rawdata/downloadtables/${entityTypeId}/${entityId}`,true);
            const form = $("<form class='downloadAllTables' action='" + appName + URL + "' method='GET'/>");
            $("body").append(form);
            $.ajax({
                dataType: "json",
                type: 'GET',
                url: addtStamp(`/rawdata/fetchCliCount/${entityTypeId}/${entityId}`, true),
                success: function (response, status) {
                    if(status === "success") {
                        if(response.cliDataCount) {
                            if (response.isSchedulerCall) {
                                downloadAllTablesScheduleCallFunc(URL);
                            } else {
                                downloadAllTablesSubmitCallFunc();
                            }
                        }else{
                            Toaster.create(intl_msg[23609], {iconClass: "icon-Information_filled"});
                        }
                    }
                },
                error: function (jqXHR) {
                    if(jqXHR.responseText)
                        Toaster.create(jqXHR.responseText);
                }
            })
        }

        function downloadAllTablesSubmitCallFunc() {
            Toaster.create(intl_msg[23555], {iconClass: "icon-Information_filled"});
            $(".downloadAllTables").submit();
            setTimeout(() => {
                $(".downloadAllTables").remove();
            });
        }

        function downloadAllTablesScheduleCallFunc(URL) {
            $.ajax({
                dataType: "json",
                type: 'GET',
                url: URL,
                error: function (jqXHR) {
                    if(jqXHR.responseText)
                        Toaster.create(jqXHR.responseText);
                }
            })
        }

        function formatDate(value,dateFormat,isClone) {
            if(value) {
                let date = value;
                dateFormat = dateFormat.replaceAll("d","D").replaceAll("y","Y");
                if(isClone) {
                    date = moment(value, dateFormat);
                }
                return moment(date).format(dateFormat);
            }
            return value;
        }

        function getRequiredData(contractRateCardLoaded){
            let sc = $('ng-view').scope();
            let entityTypeId = _.get(sc.data,"entityTypeId.values"),
                entityId = _.get(sc.data,"id.values");

            return {
                entityId,
                entityTypeId
            }
        }

        function checkIfDocumentUpdated() {
            let ps = getRequiredData(),
                that = this,
                suffix = ps.entityTypeId + '/' + ps.entityId;
                const tStamp = new Date().getTime();
                //366 id is for CRC and 61 is for contract list
                if(ps.entityTypeId !== 366 && ps.entityTypeId !== 61 && (that.currentSelectedTable.templateId || _.get(that,"defaultTemplate.id")))
                    return new Promise((resolve,reject) => {
                        $http.get('/lineitem/isDocumentUpdated/' + suffix + "/" + "?_t=" + tStamp+"&templateId="+(that.currentSelectedTable.templateId || _.get(that,"defaultTemplate.id"))).then(res => {
                            if(res.status == 200 && res.data) {
                                that.updatedDocInfo.docName = res.data.document_name;
                                that.updatedDocInfo.updateFlag = res.data.update_flag || false;
                                that.updatedDocInfo.lastDocUpdated = res.data.last_document_updated  ||  '';
                                that.updatedDocInfo.lastLineItemUpdated = res.data.last_line_item_updated  ||  '';
                                that.updatedDocInfo.ext = res.data.extension;
                                that.updatedDocInfo.generateDocument = res.data.generateDocument;
                            }
                        })
                    })
        }

        function uploadBulkFile(element,isBulkCreate) {
            let that = this;
            if(!element.files.length){
                Toaster.create(intl_msg[8166],{iconClass:"icon-Information_filled"});
            }
            return new Promise((resolve,reject) => {
                _.forEach(element.files, function (item) {
                    return uploadDocFiles.call(that,item, element,isBulkCreate);
                });
            })
        }

        function uploadDocFiles (file, elm, isBulkCreate) {
            let that = this;
            var fd = new FormData();
            let sFileName = file.name;
            let ps = getRequiredData(),
                urlSuffix = ps.entityTypeId+'/'+ps.entityId;

            if(that.multiTableViewAllowed) {
                const templateId = that.currentSelectedTable.templateId || _.get(that,"defaultTemplate.id");
                templateId && (urlSuffix += `?templateId=${templateId}`);
            }

            let sFileExtension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();
            let validExtensions = allowedExtensions;
            if (validExtensions.indexOf(sFileExtension) > -1) {
                fd.append("file", file);
                let reqUrl = '/rawdata/bulkcreate/' + urlSuffix;
                if (this.contractRateCardLoaded) {
                    reqUrl = '/rawdataV2/bulkcreate/' + urlSuffix;
                    fd.append("bodyJson", JSON.stringify({"data": this.data}));
                }
                if(!isBulkCreate){
                    reqUrl = '/rawdata/bulkUpdateRawdata/' + urlSuffix;
                    if (this.contractRateCardLoaded) {
                        reqUrl = '/rawdataV2/bulkUpdateRawdata/' + urlSuffix;
                        fd.append("bodyJson", JSON.stringify({"data": this.data}));
                    }
                }
                fd.append("tableName", this.currentSelectedTable.tableName);
                startLoader();
                that.postErrors = false;
                that.extError = false;
                $http.post(addtStamp(reqUrl,true), fd, {
                    transformRequest: angular.identity,
                    headers: {"Content-Type": undefined}
                }).then(function (response) {
                    stopLoader();
                    let message = '',
                        success = false;
                    var statusCode = '';
                    if(response[0]) {
                        message = _.get(response[0],"data.message");
                        //for validation Errors after post
                        that.postValidationMessage = message;
                        statusCode = _.get(response[0],"data.statusCode");
                    }else if(_.get(response,"data.message")){
                        message = _.get(response,"data.message");
                        statusCode = _.get(response,"data.statusCode");
                        //for validation Errors after post
                        that.postValidationMessage = message;
                        success = _.get(response,"data.success");
                    }
                    if(statusCode != '200' || !success){
                        that.postErrors = true;
                        $("#uploadExcel").find("input[type='file']")[0].value = ""
                    } else {
                        that.postErrors = false;
                        if(that.contractRateCardLoaded){
                            window.sarc.channelBroadcast("CommentsAndAttachmentChannel", {
                                actionType: "closeBulkCommentAndAttachmentModal"
                            }, 'CommentsAndAttachmentSubscription')
                        }else{
                            $("#upload_excel_cli").dialog("close");
                        }
                    }

                    message && Toaster.create(message, {
                        ...!success? {iconClass:"icon-Information_filled"} : {}
                    });
                });
            } else {
                that.extError = true;
                stopLoader();
            }
        };

        function getDataUrl(jsonUrl,isTimeStamp = false) {
            jsonUrl = jsonUrl.indexOf('?')<0? jsonUrl + "?version=2.0":jsonUrl + "&version=2.0";
            return isTimeStamp ? addtStamp(jsonUrl) : jsonUrl;
        }

        function checkForWordFilePreview(list) {
            let item = list && list.find(x => x.permission == 'Yes');
            return !!item;
        }

        function getWordFiles() {
            let isWord = true,
                ps  = getRequiredData(),
                URL = getDataUrl('/lineitem/contractTemplates/'+ps.entityTypeId+'/'+ps.entityId,true);
            startLoader();
            return new Promise((resolve,reject) => {
                $http.post(URL,JSON.stringify({})).then(response => {
                    stopLoader();
                    let data = null;
                    if(_.get(response,"data.length"))
                        data = response.data;
                    let openPopup = checkForWordFilePreview(data);
                    resolve({
                        data,
                        isWord:true,
                        openPopup,
                        id: ps.entityId
                    })
                });
            })
        }

        function generateDocFile(docType,wordDoc = null) {
                var that = this,
                isExcel = docType == 'excel',
                isWord = docType == 'word',
                baseUrl = "/cdr/edit",
                ps  = getRequiredData(),
                URL = getDataUrl(baseUrl+'/'+ps.entityId,true);

            startLoader();
            return new Promise((resolve,reject) => {
                $http.get(URL).then(response => {
                    var cData = _.get(response,"data.body.data");
                    _.set(cData,"lineItemDocument.values",true);
                    let cdrLineItemValue = {
                        excelDocument: isExcel,
                        wordDocument: isWord
                    }
                    if(isWord) {
                        cdrLineItemValue.entityTypeId = 78;
                        cdrLineItemValue.entityId = wordDoc.id;
                    }
                    _.set(cData,"cdrLineItem.values",cdrLineItemValue);
                    let postData = {
                        body: {
                            data:cData
                        }
                    }
                    URL = getDataUrl(baseUrl);
                    $http.post(URL,JSON.stringify(postData)).then(response => {
                        stopLoader();
                        if(_.get(response,"data.header.response.status") == 'success') {
                            Toaster.create("Document Generated Successfully");
                            if(that.generateDocDialogInstance) {
                                that.generateDocDialogInstance.close();
                                delete that.generateDocDialogInstance;
                            }
                            checkIfDocumentUpdated.call(that);
                            $('body').click();
                        }
                        resolve(false);
                    });
                })
            })
        }

        function loadDocument(item) {
            let ps = getRequiredData(),
                sc = $('ng-view').scope();
            let URL = "/lineitem/document/preview/"+ps.entityTypeId+"/"+ps.entityId+"/78/" + item.id;

            let responseObj = {
                data: {
                    documentURL: URL
                },
                contractLineItem: true
            }
            sc.renderPdfJsViewer(sc,responseObj);
        }

        function templateFileDownload(isBulkCreate = false, fromImportTable, bulkMuiData,tableData, searchString) {
            let ps = getRequiredData(),
                urlSuffix = ps.entityTypeId + '/' + ps.entityId,
                URL = '/rawdata/bulkRawdataDownload/' + urlSuffix + '?isBulkCreate=' + isBulkCreate;
            if(this.multiTableViewAllowed && tableData.id){
                const templateIdParam = `&templateId=${tableData.id}`;
                URL += templateIdParam;
            }
            urlData.call(this, URL,isBulkCreate,"",fromImportTable,bulkMuiData,tableData,searchString);
        }
        function urlData(URL,isBulkCreate,downloadFlag='',fromImportTable = false,bulkMuiData,tableData,searchString){
            let that = this;
            const rootScope = $("#data-ng-app").scope();
            if(downloadFlag !== "DOWNLOAD") {
                if(SirionUtils.isDuplicateRequest(() => {
                    rootScope.downloadAlreadyRequested = false;
                    urlData.call(this,URL,isBulkCreate,downloadFlag,fromImportTable,bulkMuiData,tableData);
                })) return;
                startLoader();
            }

            let selectAll = _.isEmpty(bulkMuiData.include) || !bulkMuiData['isSelectedDownload'] || bulkMuiData['selectAll'] ? true: false;
            let fltrQuery = $("#elasticSearchFilter textarea").val().replace(/\n/g, "");
            let docIds = [];
            let columns = tableData.columns?.reduce((acc, col) => {
                acc.push(col);
                return acc;
            }, []);
            if(this.isDefaultBulkTemplateDownload) {
                delete this.isDefaultBulkTemplateDownload;
                if(!columns || !columns.length)
                    columns = this.defaultTemplateColumns || [];
            }
            if (!isBulkCreate) {
                columns.unshift("rowNum");
                let rowIds = _.keys(this.selected);
                if (rowIds && rowIds.length) {
                    _.forEach(key => {
                        if (key.indexOf('dummy') != -1 && this.selected[key])
                            docIds.push(key);
                    })
                }
            }
            if (columns && columns.length) {
                if(downloadFlag !== "DOWNLOAD") {
                    var fd = new FormData();
                    fd.append("docIds", this.selectedRowsToPost || docIds.join(','));
                    fd.append("columns", columns.join(','));
                    fd.append("selectAll", selectAll);
                    fd.append("filterQuery", fltrQuery);
                    fd.append("searchString", searchString || "");
                    filteredCount -= _.keys(this.downloadData.exclude).length;

                    $.ajax({
                        dataType: "json",
                        async: true,
                        transformRequest: angular.identity,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        data: fd,
                        url: URL,
                        success: function (data) {
                            if(data.message) {
                                Toaster.create(data.message);
                            }
                            window.sarc.channelBroadcast("contractLineItemChannel", {
                                actionType: "resetPaginatedData",
                                payload: [],
                            }, "contractLineItemChannelSubscription")

                            stopLoader();
                        },
                        error: function (jqXHR) {
                            if(jqXHR.responseText)
                                Toaster.create(jqXHR.responseText, {iconClass: "icon-Information_filled"});
                        }
                    })
                } else {
                    var form = $("<form id='downloadSheet' action='" + appName + URL + "' method='POST'/>");
                    var inputf = $("<input type='hidden' name='columns' value='" + columns.join(',') + "'/>");
                    var inputs = $("<input type='hidden' name='selectAll' value='" + selectAll + "'/>");
                    var inputfq = $("<input type='hidden' name='filterQuery' value='" + fltrQuery + "'/>");
                    var inputss = $("<input type='hidden' name='searchString' value='" + (searchString || "") + "'/>");
                    if (!isBulkCreate && !isXsl) {
                        const docIdsString = docIds.join(',');
                        var inputd = $("<input type='hidden' name='docIds' value='" + (this.selectedRowsToPost || docIdsString) + "'/>");
                        form.append(inputd);
                    }
                    form.append(inputf);
                    form.append(inputs);
                    form.append(inputfq);
                    form.append(inputss);
                    $("body").append(form);

                    Toaster.create(intl_msg[23555], {iconClass: "icon-Information_filled"});
                    $("#downloadSheet").submit();
                    filteredCount = this.filteredCount;

                    setTimeout(() => {
                        $("#downloadSheet").remove();
                    })
                }
            }
        }
    }]);
})();
